export default __webpack_public_path__ + "static/media/Master_Certified_Mentor.c1b84fc7.png";